<template>
  <!-- CPAP 申請詳細 -->
  <div id="CpapRequestDetail" class="printTarget">
    <div id="container-center" v-bind:key="renderKey">
      <!-- CPAP 申請詳細の場合　表示 -->
      <div class="labelTitle lable printTarget">CPAP 申請詳細</div>
      <div class="button-area unPrintTarget">
        <!-- CPAP 申請詳細の場合　以下のボタン表示 -->
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
        <b-button class="backButton is-primary" v-if="type=='showReq'||type=='editReq'||type=='showTemp'||type=='showIns'||type=='editIns'" style="right: 20px;" icon-left="printer" @click="print">印刷</b-button>
      </div>
      <div id="item-contens">
        <!--仮持出申込(申込中)-->
        <cpapRequestDetailEdit class="printTarget" v-if="type=='editTemp'" ref="detailEdit" :data="targetData" :innerUser="false"/>
        <!--処方申込(申込中/登録済み), 処方変更(申込中/登録済み), 仮持出申込(登録済み)-->
        <cpapRequestDetail class="printTarget" v-else-if="type=='showReq'||type=='editReq'||type=='showTemp'||type=='showCancel'||type=='editCancel'" ref="detail" :data="targetData" :showRequestInfo="true" :innerUser="false" :kind="targetData.kind" :cancelEdit="mode=='edit'" :deliveryHidden="targetData.depositUseFlag || targetData.notDirections"/>
        <!-- 預託院内在庫
        <CpapEscrowRequestDetail class="printTarget" v-else-if="type=='showEscrow'" ref="detail" :data="targetData" :showRequestInfo="true" :innerUser="false" :kind="targetData.kind" :cancelEdit="mode=='edit'" :deliveryHidden="targetData.depositUseFlag || targetData.notDirections"/> -->
        <!--預託機申込(申込中/登録済み)-->
        <cpapInstrumentRequestDetail class="printTarget" v-else-if="type=='showIns'||type=='editIns'" :data="targetData" :showRequestInfo="true"/>
        <div class="button-area unPrintTarget">
          <!-- ログインユーザーが医療機関(ディーラー)かつ仮持出、処方中止の場合、「保存する」ボタン表示 -->
          <b-button v-if="(isHospital||isDealer)&&(type=='editTemp'||type=='editCancel')" class="receptionistButton is-primary" @click="save">保存する</b-button>
          <!-- ログインユーザーが医療機関(ディーラー)かつ、指示書なし(仮持出)で未承認の場合「承認する」ボタン表示 -->
          <!-- QA71 キャンセル対象外 -->
          <b-button v-if="(isHospital||isDealer)&&targetData.notDirections&&!targetData.approvalFlag&&status !=15" class="receptionistButton is-primary" @click="approval">承認する</b-button>
          <!-- 申請中の場合、キャンセルボタン表示 -->
          <button v-if="type=='editReq'||type=='editIns'||type=='editCancel'||type=='editTemp'" class="button is-primary" type="button" slot="trigger" @click="cancelReasonInputModalActive=true">キャンセル</button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal v-on:setReason="cancel" v-bind:title="'キャンセル理由入力'"></reasonInputModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import CpapRequestDetailEdit from "@/components/mock/common/CpapRequestDetailEdit";
import CpapInstrumentRequestDetail from "@/components/mock/common/CpapInstrumentRequestDetail";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import CpapEscrowRequestDetail from "@/components/mock/common/CpapEscrowRequestDetail";

export default {
  name: "CpapRequestDetail",
  methods: {
    back: function() {
      this.$router.push({
        name: "CpapRequestList",
        params: { searchConditions: this.searchParams },
      });
    },
    doSearch: function() {
      var excuteApi = this.getCpapRequestDetailsPOST;
      var successCallBack = this.getCpapRequestDetailsPOSTSuccess;
      var errorCallBack = this.getCpapRequestDetailsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapRequestDetailsPOST: function(client) {
      return client.apis.externalCpap.getCpapRequestDetailsPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getCpapRequestDetailsPOSTSuccess: function(result) {
      // 検索結果取得
      this.targetData = result.obj
      this.mode = "show";
      this.kind = "Req";
      var progress = this.getCpapProgres(this.targetData.status)
      if(progress.indexOf("仮受付") != -1) {
        this.mode = "edit";
      }
      
      var type = this.getCpapKind(this.targetData.kind)
      if(type.indexOf("預託機申込み") != -1){
        this.kind = "Ins"
      }else if(type.indexOf("仮持出申込み") != -1){
        this.kind = "Temp"
      }else if(type.indexOf("処方中止申込み") != -1){
        this.kind = "Cancel"
      }
      this.type = this.mode + this.kind
      this.reportFormatType = this.targetData.reportFormatType
      this.renderKey = !this.renderKey
    },
    getCpapRequestDetailsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.message,this.back());
    },
    cancel: function(cancelReason) {
      // 申請取下げ
      this.reason = cancelReason
      var excuteApi = this.setCpapRequestWithdrawPOST;
      var successCallBack = this.setCpapRequestWithdrawPOSTSuccess;
      var errorCallBack = this.setCpapRequestWithdrawPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapRequestWithdrawPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      obj.reason = this.reason
      return client.apis.externalCpap.setCpapRequestWithdrawPOST({
        body:obj
      });
    },
    setCpapRequestWithdrawPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestWithdrawPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    print: function(){
      window.print();
    },
    save: async function() {
      var child = this.$refs.detailEdit;
      if(this.type=='editCancel'){
        var child = this.$refs.detail;
      }
      
      if (!this.targetData.existingFlag) {
      const validateResult = await child.$validator.validateAll()
      if (!validateResult) {
        this.showErrorMessage("入力内容に誤りがあります。")
        return
      }
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      }
      var excuteApi = this.setCpapRequestSavePOST;
      var successCallBack = this.setCpapRequestSavePOSTSuccess;
      var errorCallBack = this.setCpapRequestSavePOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapRequestSavePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""

      if(this.reportFormatType == obj.reportFormatType) delete obj.model
      if(this.reportFormatType != obj.reportFormatType) delete obj.serial
      return client.apis.internalCpap.setCpapRequestSavePOST({
        body:obj
      });
    },
    setCpapRequestSavePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    approval: async function() {
      // 指示書承認
      var child = this.$refs.detailEdit;
      if(child && child.length > 0){
        const validateResult = await child.$validator.validateAll()
        if (!validateResult) {
          this.showErrorMessage("入力内容に誤りがあります。")
          return
        }
      }
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      var elements2 = document.getElementsByClassName(2)
      var result2 = this.selfMadeValidation(elements2)
      if(result2.isError){
        this.showErrorMessage(result2.msg)
        return
      }
      var excuteApi = this.setCpapTemporaryApprovalPOST;
      var successCallBack = this.setCpapTemporaryApprovalPOSTSuccess;
      var errorCallBack = this.setCpapTemporaryApprovalPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    setCpapTemporaryApprovalPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.targetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""

      if(this.reportFormatType == obj.reportFormatType) delete obj.model
      if(this.reportFormatType != obj.reportFormatType) delete obj.serial
      return client.apis.externalCpap.setCpapTemporaryApprovalPOST({
        body:obj
      });
    },
    setCpapTemporaryApprovalPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.back();
    },
    setCpapTemporaryApprovalPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var targetKind = this.$route.params["kind"];
    var targetStatus = this.$route.params["status"];
    var searchParams = this.$route.params["searchConditions"];

    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var mode = "show";
    var kind = "Req";
    var progress = this.getCpapProgres(targetStatus)
    if(progress.indexOf("仮受付") != -1) {
      mode = "edit";
    }
    var type = this.getCpapKind(targetKind)
    if(type.indexOf("預託機申込み") != -1){
      kind = "Ins"
    }else if(type.indexOf("仮持出申込み") != -1){
      kind = "Temp"
    }else if(type.indexOf("処方中止申込み") != -1){
      kind = "Cancel"
    }
    // 新規処方、処方変更、処方中止、転院、処方再開、仮持出(登録済み)、機器返却(預託機)
    //   ⇒　CpapRequestDetail
    // 仮持出申込(申込み中)
    //   ⇒　cpapRequestDetailEdit
    // 預託機申込
    //   ⇒　cpapInstrumentRequestDetail
    
    // 医療機関の場合、仮持出の確定が可能
    
    // 下記申請中の申込キャンセルが可能
    // 新規処方、処方変更、処方中止、転院、処方再開、預託機申込、機器返却(預託機)
    return {
      targetNumber,
      searchParams,
      targetData: {},
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      role: role,
      extUserStatus: extUserStatus,
      type: mode + kind,
      mode:mode,
      kind: targetKind,
      status:targetStatus,
      cancelReasonInputModalActive:false,
      reason:"",
      reportFormatType:"",
      renderKey:false
    };
  },
  filters: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    cpapRequestDetail:CpapRequestDetail,
    cpapRequestDetailEdit:CpapRequestDetailEdit,
    cpapInstrumentRequestDetail:CpapInstrumentRequestDetail,
    reasonInputModal:reasonInputModal,
    CpapEscrowRequestDetail,
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
.historyTable-area {
    max-height:500px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.historyTable {
    width: 1150px !important;
}
.historyTable .date {
    width:120px !important;
}
.historyTable .operation {
    width:80px !important;
}
.historyTable .detail {
    width:500px !important;
}
.historyTable .operator{
    width:250px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequestDetail.vue